export default `
  
  fragment variantsFields on VariantType {
   
    id 
    user_product_id
    title 
    price
    currency
    availableQuantity
    condition
    family_id
     condVentas{
    id,
    price,
    currency,
    isCatalogo
    }
    variants
    href
    thumbnail
    siteId
    status
    pictures{
    id
    url
    secure_url}
    images {
      id
      url
      secure_url
    } 
       country {
      code 
      name
    }
    approved {
      author {
        id
        givenName
        familyName
      }
      createdAt
    }
    reported {
      tags {
        display
        active
      }
      code 
      description
      photosDenounced
      author {
        id
        givenName
        familyName
      }
      createdAt
    } 
    noticed {
      sent
      reason
      failed 
      sending
      noticeId
      noticedAt
      takeDownAt
    }
    originModel
    isReported
  }
`;
